import * as yup from "yup";

const ERROR_MESSAGES = {
  email: "E-Mail ergänzen",
  emailFormat: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  phoneNumber: "Telefonnummer ergänzen",
  invalidNumber: "Bitte gültige Telefonnummer angeben",
};

const EMPTY_FIELDS_MESSAGES = {
  email: "E-Mail ergänzen",
  phoneNumber: "Telefonnummer ergänzen",
};

const schema = yup.object().shape({
  email: yup
    .string()
    .required(ERROR_MESSAGES.email)
    .email(ERROR_MESSAGES.emailFormat),
  phoneNumber: yup
    .string()
    .required(ERROR_MESSAGES.phoneNumber)
    .test("check number format", ERROR_MESSAGES.invalidNumber, (number) => {
      // match works almost (not exactly) like desktop version (PJPP)
      // app/lib/model_validators/basic_phone_number_validator.rb:L3
      const match = /^[+]?\d{2}[\s\d-]{5,}$/.test(number);

      return !(number && !match);
    }),
});

export { schema, ERROR_MESSAGES, EMPTY_FIELDS_MESSAGES };
